import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areExpansionPanelStatesEqual, EXPANSION_PANEL_INITIAL_STATE } from './cost-to-build-client-ui-expansion-panel.state';
import type { ExpansionPanelState } from './cost-to-build-client-ui-expansion-panel.types';

export const ExpansionPanelStore = signalStore(
    withState(EXPANSION_PANEL_INITIAL_STATE),
    withComputed((store) => ({
        state: computed<ExpansionPanelState>(() => ({
            isOpen: store.isOpen(),
            number: store.number(),
            title: store.title(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<ExpansionPanelState>) => {
            const nextState: ExpansionPanelState = {
                ...store.state(),
                ...patch,
            };

            if (areExpansionPanelStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return {
            close() {
                setState({ isOpen: false });
            },
            open() {
                setState({ isOpen: true });
            },
            setState,
            toggle() {
                setState({ isOpen: !store.isOpen() });
            },
        };
    })
);
